import React from "react";
import "./styles/Skills.css";

const Skills = () => {
  const skills = {
    "DevOps & Cloud": ["Docker", "AWS (EC2, S3)", "CI/CD"],
    Backend: [
      "NestJS",
      "Spring Boot",
      "Node.js",
      "Express.js",
      "Java",
      "RESTful API",
      "Microservices",
      "gRPC",
    ],
    Frontend: ["React", "TypeScript", "TailwindCSS", "HTML5", "CSS3"],
    Databases: ["MongoDB", "PostgreSQL", "MySQL"],
    "Messaging & Real-Time": ["Socket.IO", "Kafka"],
    "Security & Auth": ["JWT", "OAuth 2.0", "Spring Security"],
    Tools: ["Git", "GitHub", "Linux", "Bash", "Postman", "Jira"],
  };

  return (
    <section id="skills" className="skills-section">
      <h2>Skills</h2>
      <div className="skills-container">
        {Object.entries(skills).map(([category, skillList]) => (
          <div key={category} className="skill-category">
            <h3>{category}</h3>
            <div className="skill-list">
              {skillList.map((skill, index) => (
                <div key={index} className="skill-item">
                  {skill}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Skills;
